import * as type from './types';
import axios from '../../../common/config/axios';


//Call the api for example call the login api
export const getAdminsLoginHistory = (data) => dispatch => {
    axios.get('admin_login_history/list', {
        params: data
    }).then((response) => {
        //Dispatch the current page , current limit and search value to reducers
        dispatch({
            type: type.GET_ADMIN_LOGIN_HISTORY_LIST,
            payload: response
        })
    }).catch(err => {
        // console.warn(err);
    })

};